import { encodeParam } from "utilities/misc";
import { get } from "utilities/network";

export interface AdminDashboardStats {
  totalRegisteredUsers?: number;
  totalActiveUsers?: number;
  totalBalance?: number;
  totalVendorsBalance?: number;
  totalUsersBalance?: number;
  usersNairaBalance?: number;
  totalCryptoBalances?: number;
  totalRecurring?: number | string;
  cryptoBalances?: Record<string, number>;
  rate?: { buy: { usd?: number } };
  actionQueue?: {
    pendingKycEscalations?: number;
    flaggedTransactions?: number;
  };
}

export const httpDashboardStats = (): Promise<{
  stats: AdminDashboardStats;
}> => {
  return get(`admin/stats/dashboard`);
};

export const httpBalances = (type: string) => {
  return get(`admin/balances/${encodeParam(type)}`);
};

export const httpGetRate = () => {
  return get(`admin/transactions/rate`);
};

export const httpAnalytics = (type: string, which: string, date: string) => {
  return get(
    `admin/analytics/${encodeParam(type)}?which=${encodeParam(which)}&date=${encodeParam(date)}`,
  );
};

export const httpTransactionAnalytics = (type: string, date: Date | string) => {
  return get(
    `admin/analytics/transactionAnalytics?date=${encodeParam(date)}&type=${encodeParam(type)}`,
  );
};

export const httpFetchPaymentMerchants = () => {
  return get(`admin/transactions/paymentMerchants`);
};
